import Axios from 'axios'

import { Config, Header as HeaderPlain } from '../../config.api'

const Header = async () => {
  const header = await HeaderPlain()
  header.headers['by-pass'] = true
  return header
}

const GetDashboardTrafficInformation = async ({ filters }) => {
  try {
    const response = await Axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/vessel-forecast-traffic?filter=${filters}`,
      await Header()
    )
    return response.data
  } catch (error) {
    console.log(error)
  }
}

export default {
  GetDashboardTrafficInformation
}